export const luckyorangeTrackEven = (eventName, userEmail) => {
  if (!window.LOQ) return;
  window.LOQ = window.LOQ || [];

  window.LOQ.push([
    'ready',
    async (LO) => {
      try {
        // Wait until the Lucky Orange events API is ready
        await LO.$internal.ready('events');
        // Track the event
        LO.events.track(eventName);
      } catch (error) {
        console.warn('[LO] trackEven error:', error);
        // You can ignore or handle it gracefully here
      }
    },
  ]);
};


export function luckyorangeIdentifyUser(userEmail) { 
  /* if (!window.LOQ) return; */
  window.LOQ = window.LOQ || [];

  window.LOQ.push([
    'ready',
    async (LO) => {
      try {
        // Wait for Lucky Orange visitor API
        await LO.$internal.ready('visitor');
        // Identify the visitor
        LO.visitor.identify({ email: userEmail });
      } catch (error) {
        console.warn('[LO] identifyUser error:', error);
      }
    },
  ]);
}